import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/page/v2', Object.assign({}, options, {
    params
  }));

export const userList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/users/v2', Object.assign({}, options, {
    params
  }));

export const shopList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/shopSelections/v2', Object.assign({}, options, {
    params
  }));

export const shopListAdmin = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/shopListAdmin/v2', Object.assign({}, options, {
    params
  }));

export const syncShop = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/sync/v2', qs.stringify(params), options);

export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/update/v2', params, options);

// v4ward/park/coupon/coupon/selectionList
// 获取券
export const selectionList = (params, options) =>
  request.get('/api/v4ward/park/coupon/coupon/selectionList/v2', Object.assign({}, options, {
    params
  }));

// 发券详情 列表
export const getCouponsDetailsPage = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/record/page/v2', Object.assign({}, options, {
    params
  }));

// 发券详情 新增
export const couponsDetailssave = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/record/save/v2', params, options);
// 发券详情 修改
export const couponsDetailsUpdate = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/record/update/v2', params, options);

// 商家充值页面
export const getShopRechargeView = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/shopRecharge/v2', Object.assign({}, options, {
    params
  }));

// 计算商家实缴金额
export const shopAmountCalculate = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/shopRecharge/calculateMoney/v2', params, options);

// 商家充值数据保存
export const shopRechargeSave = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/shopRecharge/save/v2', qs.stringify(params), options);

// 商家充值明细列表
export const getShopRechargeDetailList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/recharge/page/v2', Object.assign({}, options, {
    params
  }));

//删除给商家的优惠券
export const couponDetailDelete = (params, options) =>
  request.post('/api/v4ward/park/coupon/shop/record/delete/v2', qs.stringify(params), options);
